// extracted by mini-css-extract-plugin
export default {"up":"styles_up__EAUYf"};